<template>
    <div>
        <errors v-if="error_messages" :errors="error_messages"></errors>
        <div class="c-support-overlay js-overlay is-active">
            <div class="c-cookie">
                <h3 class="c-heading-medium u-color-white">{{ translate('frontend.js.cookie_consent.info_cookie') }}</h3>
                <p v-html="translate('frontend.js.cookie_consent.cookie_consent', {'privacy_statement_url' : '/privacybeleid'})"></p>
                <template v-if="is_cookie_set === false">
                    <div class="c-cookie-buttons-wrapper u-margin-top-small">
                        <div v-on:click.prevent="setCookie(false)" class="button outlined u-no-margin-top u-margin-right-tiny">{{ translate('frontend.js.cookie_consent.reject_cookie') }}</div>
                        <div v-on:click.prevent="setCookie(true)" class="button is-secondary u-no-margin-top">{{ translate('frontend.js.cookie_consent.accept_cookie') }}</div>
                    </div>
                </template>
                <template v-else>
                    <form class="c-form js-form-animation" v-on:submit.prevent="updatePreferences">
                        <div class="c-cookie-switch-wrapper u-margin-top-small">
                            <span class="u-bold u-white u-margin-right-tiny">{{ translate('frontend.js.cookie_consent.accept_cookie') }}</span>
                            <div class="switch u-margin-left-tiny u-no-margin-bottom">
                                <input v-model="form.is_accepted" class="switch-input" id="switch" type="checkbox">
                                <label class="switch-paddle" for="switch"></label>
                            </div> 
                        </div>
                        <div class="c-cookie-buttons-wrapper u-margin-top-small">
                            <button type="submit" class="button is-secondary u-no-margin-top u-no-margin-bottom" :disabled="disable_submit">{{ translate('frontend.js.cookie_consent.save_cookie') }}</button> 
                        </div>
                    </form>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue              from 'vue';
    import Errors           from '../ui/errors';

    export default {
        name: 'cookie-consent',
        props: ['is_cookie_set', 'cookie_value'],
        data() {
            return {
                form: {
                    is_accepted: false
                },
                error_messages: null,
                disable_submit: false
            }
        },
        components: {
            'errors'        : Errors
        },
        mounted() {
            if( this.cookie_value !== null) {
                this.form.is_accepted = this.cookie_value;
            }
        },
        methods: {
            /**
             * Set cookie value
             *
             * @author Robin van Leeuwen <robin@click.nl>
             * @param  boolean is_accepted
             */
            setCookie( is_accepted ) {
                this.form.is_accepted = is_accepted;

                this.updatePreferences();
            },

            /**
             * Save the cookie consent preferences
             *
             * @author Robin van Leeuwen <robin@click.nl>
             * @return void
             */
            updatePreferences() {
                this.disable_submit = true;

                axios.post('/api/cookie/consent', this.form)
                    .then(this.successFullyPosted)
                    .catch(this.catchErrors);
            },

            /**
             * After the form is successfully posted
             *
             * @author Robin van Leeuwen <robin@click.nl>
             * @return void
             */
            successFullyPosted() {
                this.disable_submit = false;

                // Hide the cookie consent popup
                let cookie_div = document.getElementsByClassName('js-cookie-consent');
                cookie_div[0].classList.add( 'hide' );
                
                // Reload the page if user changes the preferences to show/hide Facebook pixel
                if( this.cookie_value !== this.form.is_accepted ) {
                    window.scrollTo(0, 0);
                    location.reload();
                }

                // Remove the disable scroll class when the user hasn't changed cookie preferences
                document.body.classList.remove('u-disable-scroll');
            },

            /**
             * Catch the errors from the form submit
             *
             * @author Robin van Leeuwen <robin@click.nl>
             * @param  error
             * @return void
             */
            catchErrors(error) {
                this.disable_submit = false;

                if(error.response.status === 422) {
                    this.error_messages = Lang.get('frontend.js.global.422_error');
                } else {
                    this.error_messages = Lang.get('frontend.js.global.error');
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/frontend/vue/components/cookie-consent/cookie-consent.vue